import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as types from "../../../constants/ComponentConstants";
import * as layoutActions from "../../../actions/e-loketLayoutActions";
import { validatieStatussenLoaded } from "../../../actions/validatieStatusActions";
import * as ajaxActions from "../../../actions/ajaxCounterActions";
import { throwException } from "../../../actions/exceptionActions";

import PublicatieForm from "./PublicatieForm";
import Section from "../../common/Section";
import redirector from "../../../util/redirector";
import PublicatiePageHelper from "./PublicatiePageHelper";
import EasterEggHandler from "../../common/EasterEggHandler";
import * as pageConstants from "../../../constants/EasterEggConstants";
import ScrollToFirstErrorComponent from "../../common/ScrollToFirstErrorComponent";

class PublicatiePage extends ScrollToFirstErrorComponent {
    constructor(props, context) {
        super(props, context, true);

        this.state = {
            model: { },
            errors: null,
            hasUnsavedChanges: false,
            disabled: false,
            scrollToTop: false,
            shouldScrollToFirstError: false
        };

        this.pageHelper = new PublicatiePageHelper(this, redirector);
        this.testFiller = new EasterEggHandler(this, pageConstants.WIJZIG_PUBLICATIE);
    }

    componentDidMount = () => {
        const params = this.props.match.params;
        const modelId = params.modelId;

        if (this.props.shouldRedirect)
            redirector.goTo(`e-loket/organisator/${modelId}/false`);
        else {
            this.testFiller.bind();
            super.componentDidMount(); // better way to handle unsaved changes
            this.pageHelper.init();
        }
    };

    componentWillUnmount() {
        this.testFiller.unbind();
        this.state = {
            model: null
        };
    }

    componentDidUpdate = () => {
        super.componentDidUpdate();

        if (this.state.scrollToTop) {
            window.parent.scrollTo(0, 450);
            this.setState({
                scrollToTop: false
            });
        }
    };

    handleOnSave = () => this.pageHelper.save();
    handleOnChange = (event, toelatingId) => this.pageHelper.change(event, toelatingId);
    handleOnGetError = (propertyName, toelatingId) => this.pageHelper.getErrorForProperty(propertyName, toelatingId);
	handleOnChangeRadio = event => this.pageHelper.changeRadio(event);
	handleOnChangeSubcomponent = (event) => this.pageHelper.changeSubcomponent(event);
	handleOnConfirmVoorzieningenPopup = () => this.pageHelper.confirmVoorzieningenPopup();

    render() {
        const state = this.state;
        const props = this.props;
        const model = state.model;
        const disabled = props.disabled;
        const color = types.COLOR_BLUE_DARK;
		const showVoorzieningenPopup = state.showVoorzieningenPopup;

        return (
            <Section title={"Gegevens voor publicatie"} color={color}>
                <PublicatieForm
                    model={model}
                    onChange={this.handleOnChange}
					onChangeRadio={this.handleOnChangeRadio}
					onChangeSubcomponent={this.handleOnChangeSubcomponent}
                    onSave={this.handleOnSave}
                    getError={this.handleOnGetError}
                    disabled={disabled}
                    color={color}
                    validationMessageType={this.state.validationMessageType}
					showVoorzieningenPopup={showVoorzieningenPopup}
					onConfirmVoorzieningenPopup={this.handleOnConfirmVoorzieningenPopup}
                />
            </Section>);
    }
}

PublicatiePage.propTypes = {
    loadLayout: PropTypes.func
};

function mapStateToProps(state) {
    const disabled = state.settings.disabled;
    const shouldRedirect = !state.layout.topNavTabsSet;

    return {
        disabled: disabled,
        shouldRedirect: shouldRedirect
    };
}

function mapDispatchToProps(dispatch, ownProps) {
    return {
        loadLayout: bindActionCreators(layoutActions.loadPublicatieLayout, dispatch),
        validatieStatussenLoaded: bindActionCreators(validatieStatussenLoaded, dispatch),
        ajaxActions: bindActionCreators(ajaxActions, dispatch),
        throwException: bindActionCreators(throwException, dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(PublicatiePage);